import React, { useState } from "react";

interface FAQ {
  question: string;
  answer: string;
}

const mockFAQs: FAQ[] = [
  {
    question: "How can I check my College Mentor Scholarship Test 2025 result?",
    answer:
      "Log in to your result dashboard at www.collegementor.com/college-mentor-scholarship/results using your registered mobile number to download your certificate.",
  },
  {
    question: "I won a scholarship or cash prize — what should I do next?",
    answer:
      "Follow the instructions sent to your registered email. You will need to verify your identity and submit documents to claim your prize or scholarship.",
  },
  {
    question:
      "How do I claim my cash prize or scholarship?",
    answer:
      "Follow the instructions in the email you receive after the results are declared. For any questions, contact us at scholarship@collegementor.com.",
  },
  {
    question: "How will I receive my cash prize?",
    answer:
      "The cash prize will be transferred to your verified bank account or UPI ID after successful document verification.",
  },
  {
    question: "How will the College Mentor scholarship be applied or used?",
    answer:
      "Scholarships may be provided as fee waivers, learning credits, or enrollments in mentorship programs offered by College Mentor and its partners. Details will be mentioned in your prize confirmation email.",
  },
  {
    question: "I have written Scholarship Exam  but didnt receive results. What should I do?",
    answer:
      "Email us at :scholarship@collegementor.com / admin@collegementor.com  or call us at +91 79971 66666, +91 89595 91818",
  },
  {
    question: "I did not win. Can I participate in future College Mentor opportunities?",
    answer:
      "Absolutely! You can apply for upcoming scholarships, mentorship programs, and free webinars offered by College Mentor. Stay tuned for updates on our website and social channels.",
  },
  {
    question:
      "Can I transfer my scholarship to someone else?",
    answer:
      "No, scholarships and cash prizes are non-transferable and can only be claimed by the original registered participant.",
  },
  {
    question: "Are there any additional benefits for College Mentor scholarship recipients?",
    answer:
      "Yes, apart from the prize, you may receive exclusive access to mentorship sessions, early event invites, and premium content for academic growth.",
  }
];

const KnowledgeHubFAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-[#E2F3FF] py-6 px-6 lg:px-20">
      <div className="max-w-4xl max-md:w-full">
        <h2 className="text-[40px] font-bold text-[#2B2B2B] mb-6">
          Knowledge Hub (FAQ's)
        </h2>
        <div className="flex flex-col gap-3">
          {mockFAQs.map((faq, index) => (
            <div key={index} className=" py-2">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between text-left text-[#2B2B2B] text-lg font-semibold"
              >
                <div className="flex items-center gap-4">
                  <span className="text-sm bg-[#004AAD] text-white rounded-md flex items-center justify-center w-8 h-8">
                    {openIndex === index ? "−" : "+"}
                  </span>
                  <span className="max-md:w-[300px]">{faq.question}</span>
                </div>
              </button>
              {openIndex === index && (
                <div className="mt-2 text-[#4F4F4F] text-sm pl-12 ">
                  <p className="leading-6">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KnowledgeHubFAQ;
